<template>
  <div v-if="time" class="flex items-center gap-2 text-sm whitespace-nowrap text-foreground">
    <span
      class="flex size-7 items-center justify-center rounded-full"
      :class="
        isRunningOut ? 'bg-warning-muted text-warning-muted-foreground' : 'bg-info-muted text-info-muted-foreground'
      ">
      <LockClosedIcon class="size-4" aria-hidden="true" />
    </span>
    <span class="flex">
      <span :class="compact ? 'hidden md:block' : 'block'">{{ $t("Tickets held for") }} </span>&nbsp;<span
        class="tabular-nums"
        >{{ time }}</span
      >
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import LockClosedIcon from "~icons/ic/outline-lock";
import { useCartStore } from "@/store/cart.ts";

// `compact` drops the "Tickets held for" text below md, leaving just the time.
defineProps<{ compact?: boolean }>();

const { t } = useI18n();
const cartStore = useCartStore();

const FIVE_MINUTES = 5 * 60 * 1000;
const TWO_MINUTES = 2 * 60 * 1000;

// Whole minutes in words ("9 minutes") while there is plenty of time; from under five minutes a
// running mm:ss clock ("04:59").
const time = computed(() => {
  const ms = cartStore.timeLeft;
  if (!ms) return;

  if (ms >= FIVE_MINUTES) return t("{count} minutes", { count: Math.floor(ms / (1000 * 60)) });

  const seconds = Math.floor((ms / 1000) % 60);
  const minutes = Math.floor(ms / (1000 * 60));

  return [minutes, seconds].map((unit) => String(unit).padStart(2, "0")).join(":");
});

// Two minutes or less: the timer turns to the warning colours.
const isRunningOut = computed(() => !!cartStore.timeLeft && cartStore.timeLeft <= TWO_MINUTES);
</script>
